<template>
  <div class="order">
    <div class="container">
      <div class="order-box">
        <!-- <el-form :model="queryParams" ref="queryForm" :inline="true" class="form-inline">
          <el-form-item label="型号" prop="version_id">
            <el-select v-model="queryParams.version_id" placeholder="请选择型号">
              <el-option :value="0" disabled label="请选择型号"> </el-option>
              <el-option v-for="item in versionList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品批号" prop="origin_no">
            <el-input v-model="queryParams.origin_no"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query">查询</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
          </el-form-item>
        </el-form> -->
        <div>
          <el-button type="primary" @click="add">新增订单</el-button>
        </div>
        <el-table :data="tableData" height="250" border style="width: 100%">
          <el-table-column prop="qrcode" label="质保码" width="120">
            <template slot-scope="scope">
              <div class="used">{{ scope.row.cards_count >= scope.row.num ? '质保卡已用完' : '' }}</div>
              <qriously
                :value="`${frontUrl}/card?origin_no=${scope.row.origin_no}`"
                :size="100"
                v-if="scope.row.status === 1"
              />
              <el-tag type="danger" v-else-if="scope.row.status === 0">待审核</el-tag>
              <el-tag type="info" v-else-if="scope.row.status === 2">已退单</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="origin_no" label="产品批号" width="130">
            <template slot-scope="scope">
              <span class="goto-card" @click="gotoCard(scope.row)">{{ scope.row.origin_no }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="version" label="型号" width="100">
            <template slot-scope="scope">
              {{ scope.row.version.name }}
            </template>
          </el-table-column>
          <el-table-column prop="spec" label="规格" width="100"></el-table-column>
          <el-table-column prop="price" label="价格" width="100" v-if="company.show_price"></el-table-column>
          <el-table-column prop="status" label="发货状态" width="100">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.status === 1"> 已发货 </el-tag>
              <el-tag type="danger" v-else-if="scope.row.status === 0"> 待审核 </el-tag>
              <el-tag type="info" v-else-if="scope.row.status === 2"> 已退单 </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="years" label="质保年限" width="100"> </el-table-column>
          <el-table-column prop="created_at" label="创建时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" v-if="scope.row.status !== 1">
              <el-popconfirm title="确定要删除吗？" @confirm="delHandler(scope.row)">
                <el-button type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>

        <el-dialog title="新增订单" :visible.sync="dialogFormVisible" width="80%">
          <el-form :rules="rules" :model="params" ref="uForm" class="form-inline">
            <el-form-item label="门店">
              <el-input :value="company.name" disabled> </el-input>
            </el-form-item>
            <el-form-item label="地址">
              <el-input :value="company.address" disabled> </el-input>
            </el-form-item>
            <el-form-item label="联系人">
              <el-input :value="company.username" disabled> </el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input :value="company.tel" disabled> </el-input>
            </el-form-item>
            <el-form-item label="型号" prop="version_id">
              <el-select
                v-model="params.version_id"
                placeholder="请选择型号"
                @change="versionChange"
                style="width: 100%"
              >
                <el-option v-for="item in versionList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格" prop="spec">
              <el-input v-model="params.spec" disabled></el-input>
            </el-form-item>
            <el-form-item label="数量" prop="num">
              <el-input-number v-model="params.num" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="总计" v-if="company.show_price">
              <el-input :value="price" disabled></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">提交订单</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanyDetail, getVersionList, getOrderList, addOrder, delOrder } from '@/api/index'
const frontUrl = process.env.VUE_APP_FRONT_URL
export default {
  data() {
    return {
      frontUrl,
      queryParams: {
        version_id: 0,
        origin_no: ''
      },
      params: {
        company_id: 0,
        version_id: '',
        spec: '',
        num: 1
      },
      rules: {
        version_id: [{ required: true, message: '请选择型号', trigger: 'blur' }],
        spec: [{ required: true, message: '请选择型号', trigger: 'blur' }],
        num: [{ required: true, message: '请输入数量', trigger: 'blur' }]
      },
      versionList: [],
      company: {},
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      version: {
        shop_price: 0
      }
    }
  },
  computed: {
    price() {
      return this.params.num * this.version.shop_price
    }
  },
  created() {
    this.loadOrders()
    this.loadCompanyDetail()
    this.loadVersionList()
  },
  methods: {
    loadCompanyDetail() {
      getCompanyDetail()
        .then((res) => {
          this.company = res.data
          this.params.company_id = res.data.id
        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
    },
    loadVersionList() {
      getVersionList()
        .then((res) => {
          this.versionList = res.data
        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
    },
    loadOrders() {
      getOrderList({
        page: this.page,
        pageSize: this.pageSize,
        ...this.queryParams
      })
        .then((res) => {
          const { data, total } = res.data
          this.tableData = data
          this.total = total
        })
        .catch((err) => {
          console.log(err)
          this.$message.error(err.msg)
        })
    },
    versionChange(id) {
      const [version] = this.versionList.filter((item) => item.id === id)
      this.params.spec = version.spec
      this.version = version
    },
    handleCurrentChange(page) {
      this.page = page
      this.tableData = []
      this.loadOrders()
    },
    query() {
      this.page = 1
      this.loadOrders()
    },
    reset() {
      this.queryParams.version_id = 0
      this.queryParams.origin_no = ''
      this.page = 1
      this.loadOrders()
    },
    add() {
      this.dialogFormVisible = true
    },
    delHandler({ id }) {
      delOrder({ id })
        .then(() => {
          this.page = 1
          this.tableData = []
          this.loadOrders()
          this.$message.success('删除成功!')
        })
        .catch((err) => {
          this.$message.error(err.msg || '删除失败!')
        })
    },
    // 提交订单
    submit() {
      this.$refs.uForm.validate((valid) => {
        if (valid) {
          addOrder({ ...this.params })
            .then((res) => {
              this.dialogFormVisible = false
              this.page = 1
              this.tableData = []
              this.loadOrders()
            })
            .catch((err) => {
              console.log(err)
              this.$message.error(err.msg || '提交失败')
            })
        } else {
          return false
        }
      })
    },
    // 跳转提交质保页面
    gotoCard(record) {
      if (record.status === 1) {
        this.$router.push({ path: '/card', query: { origin_no: record.origin_no } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order {
  .container {
    .order-box {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 100px);
      padding: 20px;
      box-sizing: border-box;
      gap: 20px;
    }
    .goto-card {
      user-select: none;
      cursor: pointer;
    }
  }
}
.used {
  text-align: center;
  color: red;
}
</style>
